<template>
  <!--Logo start-->
  <div class="logo-main">
    <img src="@/assets/images/logo.png" width="100px" />
  </div>
  <!--Logo End-->
</template>

<script>
export default {
  props: {
    color: { type: Boolean, default: false },
  },
};
</script>
